module.exports = __webpack_public_path__ + "img/fallback_030_l.8fb4976c.jpg";